import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { recepientTableColumns } from '../../constants';
import { Subject } from 'rxjs';
import { AppUtils } from '../../utlis/app-utils';
import { FilterOverlayDialogService } from '../filter-overlay-dialog/filter-overlay-dialog.service';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { NotificationSearchService } from '../notification-search/notification-search.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SnackbarService } from '../../services/snackbar.service';
import { ResendDetailsComponent } from '../resend-details/resend-details.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'dl-notification-recipients-table',
  standalone: true,
    imports: [OneWebComponentsAngularModule,CommonModule,ResendDetailsComponent,FormsModule],
  templateUrl: './notification-recipients-table.component.html',
  styleUrl: './notification-recipients-table.component.scss'
})
export class NotificationRecipientsTableComponent {

  // @ViewChild(MatSort, { static: true }) public sort: MatSort;
  @ViewChild('exporter', { static: true }) exporter: ElementRef;
  @Input() notificationDetails: any;
  @Input() selectedRecepientColumns: any;
  @Input() contactDetails: any;
  @Input() notificationLabel: any;
  @Input() accDataObj: any;
 

  public fileData = [];
  public visibleResendDialog: boolean = false;
  public columnData: any;
  public displayedColumns = ['select', 'CustomerName', 'DateSent', 'DateDelivered', 'DateRead', 'FeedbackReceived', 'Status', 'Arrow'];
  public dataSource: any[] = [];
  selectedRows: Set<any> = new Set();
  public selection: any[] = [];
  public selectedRow: any;
  public filterArray: any[] = [];
  public filteredData: any;
  public downloadArray: any[] = [];
  public headerList: any[] = recepientTableColumns;
  public userPermission: any;
  public isAddRecipientDisabled = false;
  public isAfoBtnDisabled = false;
  public isAfoBtnExpanded = false;
  public isNewFromTemplate = false;
  public templateData: any;
  public templateColumn = ['dragHandle', 'selectType', 'selectText', 'iconSets'];
  public filteredStatusList: any;
  public updateFeedbackOptions: Subject<any> = new Subject<any>();
  public isResend: boolean = true;
  @Input() isSetCom: boolean = false;
  data: { tableData: { selectedItems: any; notificationId: any; contactNotificationId: any; }; columnData: string[]; };
  
  // Sorting properties
  sortInfo: { column: string, direction: string }[] = [];
  originalContactDetails: any[] = []; // Store original data for sorting

  public constructor(private snackBarNotification: SnackbarService, public appUtils: AppUtils, public filterOverlay: FilterOverlayDialogService,public qnsbnService: QnSbnService, public notificationSearchService: NotificationSearchService, public router: Router, public changeDetectorRef: ChangeDetectorRef) {}

  public ngOnInit(): void {  
    this.userPermission = this.qnsbnService.getUserData();
    if (this.selectedRecepientColumns > 0) {
      const recipientColumns = ['select'];
      let selectedColumns = this.selectedRecepientColumns.map(columnValue => columnValue.value);
      recepientTableColumns.forEach(colObj => {
        if (selectedColumns.indexOf(colObj.value) !== -1) {
          recipientColumns.push(colObj.value);
        }
      });
      recipientColumns.push('Arrow');
      this.displayedColumns = recipientColumns;
    }
    // Store original data for sorting
    this.originalContactDetails = [...this.contactDetails];
    this.dataSource = this.applySorting(this.contactDetails);
    if (this.contactDetails.length > 0) {
      this.filteredStatusList = this.contactDetails.map(item => item.Status).filter((value, index, self) => self.indexOf(value) === index);
      this.filterOverlay.setStatusName(this.filteredStatusList);
    }
    this.notificationSearchService.searchData$.subscribe(searchValue => {
     
      
      const filter = searchValue.toLowerCase();
      
      
      const filteredData = this.originalContactDetails.filter((data: any) => {
       
        
      return this.appUtils.getLowerCase(data.CustomerName).includes(filter) ||
        this.appUtils.getLowerCase(data.DateSent).includes(filter) ||
        this.appUtils.getLowerCase(data.DateDelivered).includes(filter) ||
        this.appUtils.getLowerCase(data.DateRead).includes(filter) ||
        this.appUtils.getLowerCase(data.FeedbackReceived).includes(filter) ||
        this.appUtils.getLowerCase(data.Status).includes(filter) ||
        this.appUtils.getLowerCase(data.CustomerContactName).includes(filter) ||
        this.appUtils.getLowerCase(data.CustomerContactEmail).includes(filter);
      });
      this.dataSource = this.applySorting(filteredData);
      this.changeDetectorRef.detectChanges();
    });
    this.filterOverlay.filterData$.subscribe(filterValue => {
      this.filterSourceTable(filterValue);
    });
    this.isAddRecipientDisabled = this.notificationDetails.notificationData[0].Status === 'Complete' || this.notificationDetails.notificationData[0].Status === 'Completed';
  }
  public ngOnChanges(changes: SimpleChanges): void {
    
    this.userPermission = this.qnsbnService.getUserData();
    if (changes['selectedRecepientColumns']) {
      const currentChanges = changes['selectedRecepientColumns'].currentValue;
      if (currentChanges.length > 0) {
        const recipientColumns = ['select'];
        let selectedColumns = currentChanges.map(columnValue => columnValue.value);
        recepientTableColumns.forEach(colObj => {
          if (selectedColumns.indexOf(colObj.value) !== -1) {
            recipientColumns.push(colObj.value);
          }
        });
        recipientColumns.push('Arrow');
        this.displayedColumns = recipientColumns;
      }
    }
    this.dataSource = this.contactDetails;
    if(this.isAddRecipientDisabled){
      this.isSetCom = true;
    }
    this.changeDetectorRef.detectChanges();
  }
    isAllSelected(): boolean {
    const enabledRows = this.dataSource.filter(row => !row.disabled);
    return enabledRows.length > 0 && enabledRows.every(row => this.selectedRows.has(row));
  }

  /** Whether some but not all rows are selected */
  isIndeterminate(): boolean {
    const enabledRows = this.dataSource.filter(row => !row.disabled);
    return this.selectedRows.size > 0 && !this.isAllSelected();
  }

  /** Toggle all rows */
  masterToggle(): void {
    if (this.isAllSelected()) {
      this.selectedRows.clear();
    } else {
      this.selectedRows = new Set(this.dataSource.filter(row => !row.disabled));
    }
  }

  /** Toggle one row */
  toggleRow(row: any): void {
    if (row.disabled) return;

    if (this.selectedRows.has(row)) {
      this.selectedRows.delete(row);
    } else {
      this.selectedRows.add(row);
    }
  }

  public toggleSelection(row: any): void {
  if (this.isSelected(row)) {
    this.selectedRows.delete(row);
  } else {
    this.selectedRows.add(row);
  }
}

  public isSelected(row: any): boolean {
  return this.selectedRows.has(row);
}

  public getReminderSent(reminderDetails: any) {
    // [{ReminderSendStatus: "Not Sent", ReminderDueDate: "02-Feb-2022", ReminderId: 0}]
    const reminderSents = [];
    if (reminderDetails && reminderDetails.length > 0) {
      reminderDetails.forEach(reminder => {
        if (reminder.ReminderSendStatus === 'Delivered') {
          let reminderSentDate = reminder.ReminderSendDate ? reminder.ReminderSendDate : reminder.ReminderDeliveryFailedDate ? reminder.ReminderDeliveryFailedDate : reminder.ReminderDueDate;
          reminderSents.push(this.appUtils.formatDateWithTime(reminderSentDate));
        }
      });
    } else {
      reminderSents.push('');
    }
    return reminderSents.join(' / ');
  }
  public getReminderPlanned(reminderDetails: any) {
    const reminderPlanned = [];
    if (reminderDetails && reminderDetails.length > 0) {
      reminderDetails.forEach(reminder => {
        // if (reminder.ReminderSendStatus === 'Not Sent') {
          reminderPlanned.push(this.appUtils.formatDateWithTime(reminder.ReminderDueDate));
        // }
      });
    } else {
      reminderPlanned.push('');
    }
    return reminderPlanned.join(' / ');
  }

  public gotoContactDetailsPage(row) {
    let rowData = {
      customerData: row,
      isSetCom: this.isSetCom,
      notificationStatus:  this.isAddRecipientDisabled,
      notificationData: this.notificationDetails.notificationData
    };
    this.router.navigateByUrl('/contact-details', { state: { customerDetails: rowData, accDataObj: this.accDataObj } });
  }

  public filterSourceTable(filterValue: any) {
    let datesent_start = this.appUtils.formatDateOnly(filterValue.dateSent_sdate);
    let datesent_end = this.appUtils.formatDateOnly(filterValue.dateSent_edate);

    let delivered_sdate = this.appUtils.formatDateOnly(filterValue.dateDelivered_sdate);
    let delivered_edate = this.appUtils.formatDateOnly(filterValue.dateDelivered_edate);

    let dateRead_sdate = this.appUtils.formatDateOnly(filterValue.dateRead_sdate);
    let dateRead_edate = this.appUtils.formatDateOnly(filterValue.dateRead_edate);

    let feedbackReceived_sdate = this.appUtils.formatDateOnly(filterValue.feedbackReceived_sdate);
    let feedbackReceived_edate = this.appUtils.formatDateOnly(filterValue.feedbackReceived_edate);

    if (filterValue.statusFilters.length < 1 && filterValue.dateSent_sdate == '' && 
    filterValue.dateDelivered_sdate == '' && filterValue.dateRead_sdate && filterValue.feedbackReceived_sdate) {
      this.dataSource = this.contactDetails;
    } else {
      const statusFilterArray = this.contactDetails.filter(data => filterValue.statusFilters.includes(data.Status) || filterValue.statusFilters == '');

      const datedeliveredFilterArray = statusFilterArray.filter(data => (this.appUtils.formatDateOnly(data.DateDelivered) >= delivered_sdate && this.appUtils.formatDateOnly(data.DateDelivered) <= delivered_edate) || filterValue.dateDelivered_sdate == '');

      const datesentFilterArray = datedeliveredFilterArray.filter(data => (this.appUtils.formatDateOnly(data.DateSent) >= datesent_start && this.appUtils.formatDateOnly(data.DateSent) <= datesent_end) || filterValue.dateSent_edate == '');

      const datereadFilterArray = datesentFilterArray.filter(data => (this.appUtils.formatDateOnly(data.DateRead) >= dateRead_sdate && this.appUtils.formatDateOnly(data.DateRead) <= dateRead_edate) || filterValue.dateRead_sdate == '');
      const feedbackReceivedFilterArray = datereadFilterArray.filter(data => (this.appUtils.formatDateOnly(data.FeedbackReceived) >= feedbackReceived_sdate && this.appUtils.formatDateOnly(data.FeedbackReceived) <= feedbackReceived_edate) || filterValue.feedbackReceived_sdate == '');
      this.dataSource = feedbackReceivedFilterArray.filter(data => this.appUtils.getLowerCase(data.DateRead) || this.appUtils.getLowerCase(data.FeedbackReceived) || this.appUtils.getLowerCase(data.Status) || this.appUtils.getLowerCase(data.DateDelivered) || this.appUtils.getLowerCase(data.DateSent));

      
    }
    this.changeDetectorRef.detectChanges();
  }

  public displayStatus(status) {
    const statusText = status ? status : 'Pending';
    return statusText;
  }

  public ndResendNotification(): void {

    
   let selectedItems = Array.from(this.selectedRows).filter(
    item => item.Status !== "Feedback Received" && item.Status !== 'Completed'
  );
    if(selectedItems.length !== 0){
      const notificationId = this.notificationDetails.notificationData[0].NotificationId;
      const contactNotificationId = [];
      this.notificationDetails.contactData.map((item) => {
        selectedItems.some((elm) => {
          if(elm.CustomerContactEmail === item.CustomerContactEmail && elm.CustomerId === item.CustomerId){
            contactNotificationId.push(item.ContactNotificationId);
            return true;
          }
          return false;
        });
      });
      this.executeResendDetailsData(selectedItems, notificationId, contactNotificationId);
       this.snackBarNotification.snackBarMessage('alarm', 'Resend is not allowed for contacts in "Feedback received" and "Completed" Status.');
    }else{
       this.snackBarNotification.snackBarMessage('alarm', 'You cannot resend for contacts in "Feedback received" status.');
    }
  }

  public executeResendDetailsData(selectedItems, notificationId, contactNotificationId): void {
    let displayedColumns = ['CustomerId', 'CustomerName', 'CustomerContactName','CustomerContactEmail'];
    const resendData = {
      selectedItems,
      notificationId,
      contactNotificationId
    }
    this.data = { tableData: resendData, columnData: displayedColumns },
    this.visibleResendDialog = true;
    this.changeDetectorRef.detectChanges();
  }

  public OnSort(column: string, value: string): void {
    const existingSortIndex = this.sortInfo.findIndex(sort => sort.column === column);
    if (existingSortIndex !== -1) {
      this.sortInfo.splice(existingSortIndex, 1);
    }
    if (value !== 'default') {
      this.sortInfo.push({ column, direction: value });
    }
    this.dataSource = this.applySorting(this.dataSource);
    this.changeDetectorRef.detectChanges();
  }

  applySorting(data: any[]): any[] {
    const dataCopy = [...data];
    if (this.sortInfo.length > 0) {
      return dataCopy.sort((a, b) => {
        for (let i = this.sortInfo.length - 1; i >= 0; i--) {
          const { column, direction } = this.sortInfo[i];
          const aValue = a[column] ?? '';
          const bValue = b[column] ?? '';
          if (aValue < bValue) return direction === 'asc' ? -1 : 1;
          if (aValue > bValue) return direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return dataCopy;
  }

}

